<template>
  <div class="form-container narrow">
    <div class="form-header">
      <h2>Forgot Password</h2>
    </div>
    <form @submit.prevent="handleSubmit" class="form">
      <div class="form-section">
        <div class="form-group">
          <label for="email" class="required">Email</label>
          <input
            type="email"
            id="email"
            v-model="formData.email"
            class="form-control"
            required
          />
        </div>
      </div>

      <div class="error-message" v-if="error">
        Password reset instructions were not sent:<br>
        {{ error }}
      </div>
      <div class="success-message" v-if="success">
        Password reset instructions have been sent to your email.
      </div>

      <div class="form-actions vertical">
        <button type="submit" class="submit-button big" :disabled="loading">
          {{ loading ? 'Sending...' : 'Reset Password' }}
        </button>
        <router-link to="/login" class="link">Back to Login</router-link>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { forgotPassword } from '@/scripts/services/authService';

const router = useRouter();
const error = ref('');
const success = ref(false);
const loading = ref(false);

const formData = ref({
  email: ''
});

const handleSubmit = async () => {
  error.value = '';
  loading.value = true;
  const result = await forgotPassword(formData.value.email);
  success.value = (result === true);
  if (success.value) {
    setTimeout(() => {
      router.push('/login');
    }, 3000);
  } else {
    error.value = result;
  }
  loading.value = false;
};
</script>

<style scoped>
@import '../styles/shared-form.css';
</style>
